import React, { useState } from 'react';
import { Dropdown, Input, Textarea, Modal } from 'app/components';

const VenueModal = (props) => {
  const {
    venueDetails,
    isModalOpen,
    onClose,
    onSave,
    cities,
    primaryText,
  } = props;

  const [venue, setVenue] = useState(venueDetails);

  const onChange = (key, value) => {
    setVenue((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <Modal
      isOpen={isModalOpen}
      primaryText={primaryText || 'Add'}
      title="Add Venue"
      hasClose={true}
      onClickSecondaryCta={onClose}
      onClickPrimaryCta={() => onSave(venue)}
      onClose={onClose}
    >
      <div className="flex flex-col gap-3">
        <Input
          label="Venue Name"
          width="100%"
          value={venue?.venueName}
          onChange={(e) => onChange('venueName', e?.target?.value)}
        />
        <Textarea
          label="Address"
          width="100%"
          charLength={300}
          value={venue?.venueAddress}
          onChange={(e) => onChange('venueAddress', e?.target?.value)}
        />
        <Input
          label="Google Maps URL"
          width="100%"
          value={venue?.googleMapURI}
          onChange={(e) => onChange('googleMapURI', e?.target?.value)}
        />
        <Dropdown
          options={cities}
          value={venue?.venueCity}
          onChange={(value) => onChange('venueCity', value)}
          label="Select City"
          placeholder="Select City"
          width="100%"
        />
      </div>
    </Modal>
  );
};

export default VenueModal;